// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__TiLhF","legacyBtn":"MutateMid_legacyBtn__2KXtc"};